import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled from 'react-emotion';
import { Layout, ProjectListing, Wrapper, Title, SEO, Header } from 'components';
import website from '../../config/website';

const Hero = styled.section`
  background-color: ${props => props.theme.colors.darkBlue};
  margin-bottom: 1.45rem;
  h1 {
    color: ${props => props.theme.colors.white};
  }
`;

const Headline = styled.h3`
    color: ${props => props.theme.colors.white};
    line-height: 150%;
    width: 80%;
    margin-bottom: 0;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
      width: 100%;
    }
  `;

const ProjectCategory = ({
  pageContext: { projectCategory },
  data: {
    projects: { edges, totalCount },
  },
  location,
}) => (
  <Layout>
    <SEO title={`${projectCategory} | ${website._title}`} pathname={location.pathname} />
    <Header />
    <Hero>
      <Wrapper>
        {/* <Header invert /> */}
        {/* <Headline>Project Category</Headline> */}
        <Headline>{projectCategory}</Headline>
      </Wrapper>
    </Hero>
    <Wrapper>
      <ProjectListing projects={edges} />
    </Wrapper>
  </Layout>
);

export default ProjectCategory;

ProjectCategory.propTypes = {
  pageContext: PropTypes.shape({
    projectCategory: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    projects: PropTypes.shape({
      edges: PropTypes.array.isRequired,
      totalCount: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.object.isRequired,
};

export const pageQuery = graphql`
  query ProjectCategoryPage($projectCategory: String!) {
    projects: allPrismicProject(
      sort: { fields: [data___date], order: DESC }
      filter: {
        data: {
          categories: { elemMatch: { projectcategory: { document: { elemMatch: { data: { name: { eq: $projectCategory } } } } } } }
        }
      }
    ) {
      totalCount
      edges {
        node {
          uid
          data {
            title {
              text
            }
            date(formatString: "DD.MM.YYYY")
            thumbnail {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                  fixed {
                    src
                    srcSet
                    width
                    height
                  }
                }
              }
            }
            client {
              text
            }
            summary {
              text
            }
            categories {
              projectcategory {
                document {
                  data {
                    name
                    category_colour
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
